import { render, staticRenderFns } from "./launchads.vue?vue&type=template&id=82e95244&scoped=true"
import script from "./launchads.vue?vue&type=script&lang=js"
export * from "./launchads.vue?vue&type=script&lang=js"
import style0 from "./launchads.vue?vue&type=style&index=0&id=82e95244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e95244",
  null
  
)

export default component.exports